import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=5f1e9179&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=5f1e9179&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e9179",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1e9179')) {
      api.createRecord('5f1e9179', component.options)
    } else {
      api.reload('5f1e9179', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=5f1e9179&scoped=true", function () {
      api.rerender('5f1e9179', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/securityPolicy/components/edit.vue"
export default component.exports